/**
 * 3 for 2 Mix & Match — live cart progress for the Buy Once card on the PDP
 * (and the legacy callout box, same data attributes).
 * Replaces kids-3for2.js. The UK used to run two ranges (kids and
 * adult) that never pooled; since 2026-09-28 it is ONE pooled range (adult + kids
 * singles, no bundles), so there is a single id list, injected by the theme as
 * window.PROMO_3FOR2.ids (the discount's target collection). Each callout
 * counts the eligible one-time line items in the cart:
 *
 *   count 0             -> state 0 (empty bar)  "add 3…"
 *   count % 3 === 1     -> state 1 (33%)        "add 2 more…"
 *   count % 3 === 2     -> state 2 (66%)        "add 1 more…"
 *   count % 3 === 0 (>0) -> state 3 (100%)       "activated"
 *
 * Buy 2 get 1 repeats, so progress cycles per group of 3. Purely cart-driven:
 * the widget only describes what is actually in the basket (an empty basket
 * must read "add 3", never "add 2 more"). Refreshes on load, on /cart mutation
 * fetches, and on the theme's cart:open / cart:updated events.
 */
(function () {
  var FILL = { 0: 0, 1: 33, 2: 66, 3: 100 };
  var refreshing = false;
  var refreshQueued = false;
  var lastCartCount = 0;
  var lastCartTotalPence = 0;

  // Mirrors the free-shipping bar's rule: unlocked once the CART total meets
  // the store threshold (window.cartData.freeShippingThreshold, GBP).
  function freeShippingUnlocked() {
    var threshold = parseFloat(window.cartData && window.cartData.freeShippingThreshold);
    if (!isFinite(threshold) || threshold <= 0) return false;
    return lastCartTotalPence / 100 >= threshold;
  }

  function getCallouts() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-pdp-3for2-callout]'));
  }

  function getIds() {
    if (window.PROMO_3FOR2 && Array.isArray(window.PROMO_3FOR2.ids)) return window.PROMO_3FOR2.ids;
    return [];
  }

  function countEligibleInCart(cart, ids) {
    if (!cart || !cart.items || !ids.length) return 0;
    return cart.items.reduce(function (sum, item) {
      // The offer is one-time only (the discount excludes subscriptions on both
      // the qualifying and the free items), so Subscribe & Save lines never
      // count towards it — otherwise the bar could read "activated" while the
      // cart shows no discount.
      if (item.selling_plan_allocation) return sum;
      return ids.indexOf(item.product_id) !== -1 ? sum + item.quantity : sum;
    }, 0);
  }

  function stateForCount(count) {
    if (count <= 0) return 0;
    var remainder = count % 3;
    if (remainder === 0) return 3; // exact multiple of 3 -> a free item unlocked
    return remainder; // 1 or 2
  }

  function renderFromState() {
    var state = stateForCount(lastCartCount);
    getCallouts().forEach(function (el) {
      el.dataset.state = String(state);

      // Legacy callout box: a single fill whose width tracks the state. The
      // Buy Once card (Oct 2026) uses three segments styled from data-state
      // instead, so this is a no-op there.
      var bar = el.querySelector('[data-pdp-3for2-bar]');
      if (bar) bar.style.width = FILL[state] + '%';

      var status = el.querySelector('[data-pdp-3for2-status]');
      var msg = el.getAttribute('data-msg-' + state);
      // "Free shipping unlocked!" variant only when the shipping bar would also
      // show unlocked (cart total >= threshold). Optional per markup.
      var shippingMsg = el.getAttribute('data-msg-' + state + '-shipping');
      if (shippingMsg && freeShippingUnlocked()) msg = shippingMsg;
      if (status) status.textContent = msg || '';

      // Per-state footnote (falls back to the single shared text).
      var footnote = el.querySelector('[data-pdp-3for2-footnote]') || el.querySelector('.pdp-3for2__status em');
      var appliedText = el.getAttribute('data-applied-' + state) || el.getAttribute('data-applied-text');
      if (footnote) footnote.textContent = appliedText || '';
    });
  }

  function refresh() {
    if (!getCallouts().length) return;
    if (refreshing) {
      refreshQueued = true;
      return;
    }
    refreshing = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        lastCartTotalPence = cart.total_price || 0;
        lastCartCount = countEligibleInCart(cart, getIds());
        renderFromState();
      })
      .catch(function () {})
      .then(function () {
        refreshing = false;
        if (refreshQueued) {
          refreshQueued = false;
          refresh();
        }
      });
  }

  // Detect cart mutations regardless of which script triggered them.
  if (window.fetch && !window.__pdp3for2FetchPatched) {
    window.__pdp3for2FetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) {
        promise
          .then(function () {
            setTimeout(refresh, 60);
          })
          .catch(function () {});
      }
      return promise;
    };
  }

  window.addEventListener('cart:open', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
